import { useSearchParams } from "react-router-dom";

export const useModalWithUrl = (modalKey = 'modal', modalValue = 'open') => {
  const [searchParams, setSearchParams] = useSearchParams();
  
  const isOpen = searchParams.get(modalKey) === modalValue;

  const openModal = () => {
    setSearchParams(prev => {
      const newParams = new URLSearchParams(prev);
      newParams.set(modalKey, modalValue);
      return newParams;
    });
  };

  const closeModal = () => {
    setSearchParams(prev => {
      const newParams = new URLSearchParams(prev);
      newParams.delete(modalKey);
      return newParams;
    });
  };

  const toggleModal = () => {
    if (isOpen) {
      closeModal();
    } else {
      openModal();
    }
  };

  return {
    isOpen,
    openModal,
    closeModal,
    toggleModal
  };
};
